import React from "react";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";

export const Step12EventRego = ({
    currentStep
}) => {
    if (currentStep !== UpsellPanelSteps.Step12EventRego) {
        return null;
    }
    return (
        <div>
            Step12EventRego
        </div>
    );
};
